import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-swagger',
  standalone: true,
  imports: [],
  templateUrl: './swagger.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './swagger.component.scss'
})
export class SwaggerComponent {

}
